module.exports = __webpack_public_path__ + "static/img/paypal1.d0ff928.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/paypal1.png
// module id = nIi4
// module chunks = 2